import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedLayouts } from '../ducks/layouts';
import {
  deleteSavedLayoutModalLayoutIdSelector,
  showGenericErrorModal,
} from '../ducks/modals';
import { deleteSavedLayout } from '../utils/artworkServices';
import { useModalState } from '../utils/useModalState';
import { Button } from './Button';
import { Modal } from './Modal';

export function DeleteSavedLayoutModal({ show, onHide }) {
  const layoutId = useSelector(deleteSavedLayoutModalLayoutIdSelector);
  const [loading, setLoading] = useModalState(show, false);
  const dispatch = useDispatch();

  const onClickConfirm = useCallback(async () => {
    setLoading(true);
    try {
      await deleteSavedLayout(layoutId);
      // TODO optimistically delete the layout without fetch
      dispatch(getSavedLayouts());
      onHide();
    } catch (error) {
      console.error(error);
      showGenericErrorModal();
    }
  }, [layoutId, dispatch]);

  return (
    <Modal
      title="Are you sure?"
      show={show}
      onHide={onHide}
      footer={
        <>
          <Button variant="tertiary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onClickConfirm} loading={loading}>
            Confirm
          </Button>
        </>
      }
    >
      Are you sure you want to delete this layout?
    </Modal>
  );
}
